import App from './App.svelte';
import pkg from '../package.json';

import * as Sentry from "@sentry/svelte";
import { H } from 'highlight.run';

let env;

/* global WEB_ENV:readable */
if (WEB_ENV) {
    env = WEB_ENV;
} else if (window.location.toString().includes("https://cloud")) {
    env = "prod";
} else if (window.location.toString().includes("localhost")) {
    env = "local";
} else {
    env = "dev";
}

// Initialize the Sentry SDK here. 
// Please note: if you are relying on Sentry logging while working locally,
// extend with || env == 'local' below.
if (env == "prod" || env == "dev") {
    Sentry.init({
        dsn: "https://c7689f4c790b4736a6956ec74bbf2d87@o4504954674544640.ingest.sentry.io/4504954676772864",
        integrations: [
            Sentry.browserTracingIntegration(), 
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false
            })
        ],

        // This sets the sample rate to be 10%. You may want this to be 100% while
        // in development and sample at a lower rate in production
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
    
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        denyUrls: [
            /pub\.highlight\.run/i,
            /^.+blob.+slice_.+.tif.+/i
        ],

        // Use the commit hash as release
        release: pkg?.gitCommitHash,

        environment: env,

        ignoreErrors: ["FETCHING PIPELINE STATUS: 504", "FETCHING PIPELINE STATUS: 503"]

    });


    // Highlight.io instrumentation
    // NOTE: This is disabled because it seems to cause download to crash in Chromium browsers
    // TODO: Experiment with different flags to see if we can salvage something.
    // eslint-disable-next-line no-constant-condition
    if (false) {
        H.init('ve6zo3dp', {
            environment: env|| 'dev',
            version: pkg?.gitCommitHash,
            networkRecording: {
                enabled: true,
                recordHeadersAndBody: true,
                urlBlocklist: [
                    // insert urls you don't want to record here
                    // NOTE: According to highlight.io support, they do an .includes match,
                    // so an URL like facebook.com should filter out anything containing that string.
                    // But it does not seem to work. Support has been notified.
                    "ingest.sentry.io"
                ],
            },
        });
    }
}

console.log('RUNNING SVELTE APP WITH VERSION: ', pkg?.version, ', COMMIT SHA: ', pkg?.gitCommitHash, ', ENVIRONMENT: ', env);

const app = new App({
    target: document.body,
    props: {
        machine: 'hounsfield',
        buildVersion: pkg?.version || 'unknown',
        env: env
    }
});

export default app;